export default __webpack_public_path__ + "static/media/avatar-generico.66719ef8.png";